import Vue from 'vue';
import router from '../router';

/**
 * @param {*} componente Componente a ser instanciado
 * @param {*} props Propriedades a ser injetadas
 * @returns Retorna a instancia do componente criado
 */
export default function InstanciarComponenteVue(
    componente,
    props
) {
    componente.router = router;
    const ClasseComponenteVue = Vue.extend(componente);
    const instancia = new ClasseComponenteVue({
        propsData: { ...props }
    });

    instancia.$mount();

    return instancia;
}
